module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Pixels.5cfe88b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Pixels.jpg
// module id = XP7v
// module chunks = 0